<template>
    <div
        :id="uuid"
        ref="embed"
        class="oembed-wrapper"
    />
</template>

<script>
let uid = 1;
import { getYoutubeId } from '@/helpers/video';
import { loadScriptTag } from '@/helpers/utilities';

export default {
    name: 'YoutubeEmbed',
    props: {
        src: { type: String, default: undefined },
        preventSeek: { type: [String, Boolean], default: false, options: [true, false, 'forward'] }
    },
    emits: ['progress', 'duration'],
    data() {
        return {
            uuid: null,
            player: null,
            previousTime: null,

            duration: null,

            isPlaying: false,
            isMounted: false
        };
    },
    computed: {
        youtubeId() {
            if (!this.src) return;
            return getYoutubeId(this.src);
        }
    },
    watch: {
        src: {
            handler(to) {
                if (to) loadScriptTag('https://www.youtube.com/iframe_api', this.onPlayerScriptLoad);
            },
            immediate: true
        },
        isPlaying(to) {
            if (to) {
                if (!this.previousTime) this.previousTime = this.player.getCurrentTime();
            }
        },
        duration(to) {
            if (to) this.$emit('duration', to);
        }
    },
    created() {
        this.uuid = `youtube-${uid}`;
        uid += 1;
    },
    mounted() {
        this.isMounted = true;
    },
    beforeUnmount() {
        if (this.player) {
            this.player.destroy();
            this.player = null;
        }
    },
    methods: {
        onPlayerScriptLoad() {
            if (!(window.YT && window.YT.Player)) return this.$timeout(this.onPlayerScriptLoad, 1000);
            if (!this.isMounted) return this.$timeout(this.onPlayerScriptLoad, 200);
            this.player = new window.YT.Player(this.uuid, {
                width: '640',
                height: '390',
                videoId: this.youtubeId,
                playerVars: { playsinline: 1 },
                events: {
                    onStateChange: this.onYoutubeStateChange,
                    onReady: () => this.duration = this.player.getDuration()
                }
            });
        },
        onYoutubeStateChange(event) {
            if (event.data === window.YT.PlayerState.PLAYING) this.isPlaying = true;
            if (event.data === window.YT.PlayerState.PAUSED) this.isPlaying = false;
            this.checkProgress();
        },
        checkProgress() {
            if (!this.player) return;
            if (!this.isPlaying) return;

            const tick = 1000;
            const current = this.player.getCurrentTime();
            const duration = Math.min(this.player.getDuration(), this.duration);
            this.duration = duration;

            if (this.preventSeek === true || this.preventSeek === 'forward') {
                // HACK: We can't prevent seeking so we have to check for it manually
                const playbackRate = this.player.getPlaybackRate();
                const timeDiff = current - this.previousTime;
                if (timeDiff > (tick * playbackRate / 1000)) {
                    return this.player.seekTo(this.previousTime);
                }
            }

            this.previousTime = current;
            const progress = Math.round((current / duration) * 100) / 100;
            this.$emit('progress', { progress, duration: this.duration });
            this.$timeout(this.checkProgress, tick);
        },
        pause() {
            if (!this.player) return;
            this.player.pauseVideo();
        }
    }
};
</script>
